module.exports = __webpack_public_path__ + "static/media/logo.8a3574d3.png";